import { patchAccessibilityForIziButton } from "./patchAccessibilityForIziButton";

export default async function initializeIziButton() {
  if (IPPWidgetOptions.isBlock === "true") {
    await waitForBlockCheckoutLoaded();
  }

  const iziButtons = document.querySelectorAll(".izi-widget-placeholder");

  if (!iziButtons.length) return;
  if (typeof InpostIziJavsscriptWoocommerce !== "object") return;

  const tasks = Array.from(iziButtons).map(async (button) => {
    const buttonPageType = button.classList[1];
    const productId =
      buttonPageType === "izi-widget-product"
        ? button.getAttribute("data-product-id")
        : null;

    if (isGutenbergButton(button)) {
      const response = await getButtonHtml(buttonPageType, productId, true);
      button.innerHTML = changeGutenbergButtonClasses(button, response);
    } else {
      const response = await getButtonHtml(buttonPageType, productId);
      button.innerHTML = response;
    }

    window.IPPwidget.refresh();
  });

  await Promise.all(tasks);

  document.querySelectorAll(".izi-widget-placeholder").forEach((el) => {
    patchAccessibilityForIziButton(el);
  });
}

function isGutenbergButton(button) {
  return button.classList.contains("izi-widget-gutenberg");
}

function changeGutenbergButtonClasses(button, response) {
  const buttonAttributes = JSON.parse(button.getAttribute("data-attributes"));

  const variationMatch = response.match(/variation="([^"]*)"/);
  if (!variationMatch) return response;

  const newVariationClasses = [];
  buttonAttributes.variant &&
    newVariationClasses.push(buttonAttributes.variant);
  buttonAttributes.size && newVariationClasses.push(buttonAttributes.size);
  buttonAttributes.frameStyle &&
    newVariationClasses.push(buttonAttributes.frameStyle);
  buttonAttributes.background &&
    newVariationClasses.push(buttonAttributes.background);

  const newVariation = newVariationClasses.join(" ");

  const updatedResponse = response.replace(
    /variation="[^"]*"/,
    `variation="${newVariation}"`,
  );

  return updatedResponse;
}

async function waitForBlockCheckoutLoaded() {
  return new Promise((resolve, reject) => {
    const checkCondition = () => {
      const isLoadedShippingOptions = document.querySelector(
        ".wc-block-checkout__shipping-option",
      );
      const isLoadedPaymentMethod = document.querySelector(
        ".wc-block-checkout__payment-method",
      );
      const buttonPlaceholder = document.querySelector(
        ".izi-widget-placeholder",
      );

      if (
        isLoadedShippingOptions ||
        isLoadedPaymentMethod ||
        buttonPlaceholder
      ) {
        return true;
      }
      return false;
    };

    if (checkCondition()) {
      resolve();
      return;
    }

    const observer = new MutationObserver((mutations) => {
      if (checkCondition()) {
        observer.disconnect();
        resolve();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    setTimeout(() => {
      observer.disconnect();
      reject(new Error("Timeout waiting for block checkout to load"));
    }, 10000);
  });
}

async function getButtonHtml(pageType, productId = null, isBlock = false) {
  let endpoint;
  switch (pageType) {
    case "izi-widget-order":
      endpoint = "wp-json/inpost/v1/izi/widget/place_order_create";
      break;
    case "izi-widget-checkout":
      endpoint = "wp-json/inpost/v1/izi/widget/place_checkout_page";
      break;
    case "izi-widget-minicart":
      endpoint = "wp-json/inpost/v1/izi/widget/place_minicart";
      break;
    case "izi-widget-cart":
      endpoint = "wp-json/inpost/v1/izi/widget/place_basket_summary";
      break;
    case "izi-widget-product":
      endpoint = `wp-json/inpost/v1/izi/widget/place_product_card/${productId}`;
      break;
  }
  if (typeof InpostIziJavsscriptWoocommerce === "object") {
  }
  const timestamp = new Date().getTime();
  const response = await fetch(
    `${InpostIziJavsscriptWoocommerce.home_url}${endpoint}?t=${timestamp}&isBlock=${isBlock}`,
    {
      credentials: "same-origin",
      headers: {
        "Content-Type": "text/html",
        cache: "no-cache",
      },
    },
  );

  if (!response.ok) throw new Error("Network response was not ok");
  if (response.status !== 200) return;
  return await response.text();
}
